"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeMap = void 0;
var StatusTagProps_1 = require("./StatusTagProps");
exports.typeMap = new Map([
    [StatusTagProps_1.StatusTagType.EXPIRED, "bg-functional-dk-red"],
    [StatusTagProps_1.StatusTagType.PENDING, "bg-ui-medium-gray"],
    [StatusTagProps_1.StatusTagType.VERIFIED, "bg-functional-dk-green"],
]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/StatusTag/StatusTagsStylesMaps.js
// module id = 1820
// module chunks = 8